import { Typography as MUITypography, TypographyProps } from '@mui/material'

export const Typography = (props: TypographyProps) => {
    return (
        <MUITypography {...props} />
    )
}